import React from 'react'
import { useSelector } from 'react-redux'

export default function useGameTableDimensions(tempTableId) {
    const gameTableDimensions = useSelector((state) => state.gameTable.games[tempTableId].gameTableDimensions);

    if (!gameTableDimensions) {
        return {}
    }

    return gameTableDimensions
}
